import { tns } from "./../../../../../../node_modules/tiny-slider/src/tiny-slider";

const sliderGalleries = document.querySelectorAll(".gallery-slider");
const sliderQuotes = document.querySelectorAll(".quotes-slider");
// const sliderMobileOnly = document.querySelectorAll('[data-news-mobile-slider],[data-benefits-mobile-slider]')

function initSliders() {
  if (sliderGalleries) {
    for (let gallery of sliderGalleries) {
      tns({
        container: gallery,
        items: 1,
        controls: true,
        autoHeight: true,
        loop: true,
        mouseDrag: true,
        autoplay: true,
        autoplayButtonOutput: false,
      });
    }

  }
  if (sliderQuotes) {
    for (let slider of sliderQuotes) {
      tns({
        container: slider,
        items: 1,
        controls: true,
        autoHeight: false,
        loop: true,
        mouseDrag: true,
        autoplay: true,
        autoplayButtonOutput: false,
      });
    }
  }
  // if ( sliderMobileOnly ) {
  //   for (let slider of sliderMobileOnly) {
  //     tns({
  //       container: slider,
  //       items: 1,
  //       autoHeight: true,
  //       responsive: {
  //         613: {
  //           disable: true
  //         }
  //       }
  //     })
  //   }
  // }
}

export default () => {
  initSliders();
};
